module.exports = __webpack_public_path__ + "static/media/profile-press-ad.f6d0859a.png";